import useWidgetStore from "./store";

export default useWidgetStore;
